import { useQuery } from '@tanstack/react-query';
import { projectListQueries } from '../queries';
import type { ProjectFilters } from '../types/ProjectList';

export function useProjectList(filters: ProjectFilters) {
  return useQuery(projectListQueries.list(filters));
}
